'use strict';

/**
 *
 * @name: moreToLove
 *
 */

import DirectiveTemplate from './nn-more-to-love.directive.html';
import './nn-more-to-love.directive.scss';

function MoreToLoveDirective($sce, $translate, modulesAnalytics) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    transclude: true,
    link: function(scope, element) {

      scope.analytics = modulesAnalytics;
      scope.item = scope.content();
      scope.loaded = true;
      scope.item.title = scope.item.title || $translate.instant('MORE_TO_LOVE');

      scope.item.jsonData.sources.forEach(function(more) {
        more.imageUrl = $sce.trustAsResourceUrl(more.imageUrl);
        more.linkUrl = $sce.trustAsUrl(more.linkUrl);
      });

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      if (!scope.item.jsonData.sources || !scope.item.jsonData.sources[0] || !scope.item.jsonData.sources[1] || !scope.item.jsonData.sources[2]) {
        return terminate();
      }
    }
  };
}

export default MoreToLoveDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-more-to-love/nn-more-to-love.directive.js